import React from 'react';
import EditableField from './EditableField';
import DropdownField from './DropdownField';
import Subclass from './Subclass'; // Import Subclass
import './CharacterInfo.css';

import { CLASS_OPTIONS, BACKGROUND_OPTIONS, RACE_OPTIONS, ALIGNMENT_OPTIONS } from '../data/constants';

const CharacterInfo = ({ name, class: className, level, background, race, alignment, updateCharacter, character }) => {

  return (
    <div className="character-info">
      <div className="char-name">
        <label>Character Name</label>
        <EditableField path={['name']} value={name} updateCharacter={updateCharacter} />
      </div>
      <div className="char-details">
        <div>
          <label>Class</label>
          <DropdownField path={['class']} value={className} options={CLASS_OPTIONS} updateCharacter={updateCharacter} />
        </div>
        <div>
          <label>Level</label>
          <div className="level-control">
            <button
              className="level-btn"
              onClick={() => updateCharacter(['level'], Math.max(1, level - 1))}
            >-</button>
            <span className="level-value">{level}</span>
            <button
              className="level-btn"
              onClick={() => updateCharacter(['level'], Math.min(20, level + 1))}
            >+</button>
          </div>
        </div>
        <div>
          <label>Background</label>
          <DropdownField path={['background']} value={background} options={BACKGROUND_OPTIONS} updateCharacter={updateCharacter} />
        </div>
        <div>
          <label>Race</label>
          <DropdownField path={['race']} value={race} options={RACE_OPTIONS} updateCharacter={updateCharacter} />
        </div>
        <div>
          <label>Alignment</label>
          <DropdownField path={['alignment']} value={alignment} options={ALIGNMENT_OPTIONS} updateCharacter={updateCharacter} />
        </div>
      </div>

      {/* Subclass embedded here */}
      <Subclass character={{ class: className, level, subclass: character?.subclass }} updateCharacter={updateCharacter} />
    </div>
  );
};

export default CharacterInfo;
